export enum ColorPalette {
  Primary = 'primary',
  primaryLight = 'primary-light',
  Accent = 'accent',
  Success = 'success',
  Warn = 'warn',
  Default = 'default',
  Custom = 'custom'
}
